import { ApplicationService } from '@/@types/generated'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { useError } from '@/hooks/useError'
import { buildPath } from '@/routes'
import { useNavigate, useParams } from 'react-router'

interface CancelApplicationDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const CancelApplicationDialog = ({
  open,
  onOpenChange,
}: CancelApplicationDialogProps) => {
  const navigate = useNavigate()
  const { showSuccess } = useError()
  const { applicationId } = useParams()

  const _cancelApplication = async () => {
    onOpenChange(false)

    if (applicationId) {
      const response =
        await ApplicationService.cancelApplicationAsync(applicationId)

      showSuccess(response.message ?? 'Application has been cancelled')
      navigate(buildPath('/applications'))
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" variant="destructive">
        <DialogHeader>
          <DialogTitle>Cancel Application</DialogTitle>
          <DialogDescription>
            Are you sure you want to cancel the application? This cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">Close</Button>
          </DialogClose>
          <Button variant="destructive" onClick={_cancelApplication}>
            Yes, Cancel Application
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default CancelApplicationDialog
